import SectionHeading from "@/components/base/SectionHeading";

const cards = [
  {
    icon: "ri-focus-3-line",
    tone: "bg-primary-100 border-primary-200 text-primary-700",
    title: "我们做什么",
    desc: "把公开渠道中零散的说法收集起来，核对时间顺序与来源，整理成可读的事件记录，并标注仍在进行中的部分。",
  },
  {
    icon: "ri-group-line",
    tone: "bg-accent-100 border-accent-200 text-accent-700",
    title: "为谁而做",
    desc: "为想快速了解一件事来龙去脉的瓜友，也为不喜欢被情绪化标题带着走、希望看到多方口径的读者。",
  },
  {
    icon: "ri-refresh-line",
    tone: "bg-secondary-100 border-secondary-200 text-secondary-700",
    title: "怎么更新",
    desc: "热点事件按进展滚动补充；日常时段每小时刷新一次首页；晚间安排值班编辑跟进突发话题。",
  },
  {
    icon: "ri-forbid-2-line",
    tone: "bg-background-200 border-background-300 text-foreground-700",
    title: "我们不做什么",
    desc: "不点名真实人物、不编造细节、不公开投稿来源，也不把尚未证实的说法写成既定结论。",
  },
];

export default function PositioningSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <SectionHeading
        eyebrow="网站定位"
        title="做一份能看明白的吃瓜记录"
        desc="热闹之外，我们更在意信息是否清楚、来源是否可追溯。"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {cards.map((card) => (
          <div
            key={card.title}
            className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
          >
            <span
              className={`w-11 h-11 rounded-md border flex items-center justify-center mb-4 ${card.tone}`}
            >
              <i className={`${card.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="text-lg font-bold text-foreground-950">{card.title}</h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              {card.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}